import { render, staticRenderFns } from "./tax-category.vue?vue&type=template&id=3cc2cd94&"
import script from "./tax-category.vue?vue&type=script&lang=js&"
export * from "./tax-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports